import React from 'react'
import BaseSwitch from '@mui/material/Switch'

const Switch = ({...p}) => {
    return <BaseSwitch {...p} defaultChecked />
}

export default Switch
